/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
 
import styles from '../styles/notfoundscreen.module.scss'
import LanguageSwitcherContainer from '../containers/LanguageSwitcherContainer';
import { LogoText } from './LogoText';

import {ReactComponent as IconClose} from '../icons/close.svg';
import LinkFooterContainer from '../containers/LinkFooterContainer';

 interface NotfoundscreenProps {
    onUiGoTo: (route: string) => void;
}

export function Notfoundscreen(props: NotfoundscreenProps) {
    const {t} = useTranslation();

    return (
        <Container fluid className={styles.container}>
            <div className={styles.header}>
                <LogoText/>
                <div className={styles.language}><LanguageSwitcherContainer/></div>
                <button className={`${styles.buttonSub} ${styles.buttonCircle} `} onClick={() => {props.onUiGoTo('startscreen')}}><IconClose/></button>
            </div>
            <div className={styles.content}>
                <div className={styles.centerContent}>
                    <h1 className={styles.centerHeader}>{t('notfound.title')}</h1>
                    <h2 className={styles.centerSubHeader} dangerouslySetInnerHTML={{__html: t('notfound.subtitle')}}></h2>
                    <button className={`${styles.buttonPrimary} ${styles.buttonBig} ${styles.buttonStart}`} onClick={() => {props.onUiGoTo('startscreen')}}>{t('postscreen.new')}</button>
                </div>
            </div>
            <LinkFooterContainer className={styles.linkfooter} />
        </Container>
    );
};